<template id="productPlan">
  <el-row>
    <loading :fullscreenLoading="fullscreenLoading" />
    <el-col :span="24">
      <el-row :gutter="20">
        <el-col :span="16">
          <!-- 产品测算 -->
          <el-row class="functionBlock">
            <div class="Title">测算概览</div>
            <hr class="titleHr" />
            <ul class="textPart">
              <li>• 客户的风险等级为<span class="red">{{measumrePreview.riskLevel}}</span>。</li>
              <li>• 根据客户已存家庭养老金<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.currentMoney| addMoneyFilter}}元</span>，且计划每月储蓄<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.monthMoney| addMoneyFilter}}元</span>，
                <span v-if="measumrePreview.pensionIrrAndBreachMap.irr==='无法达成规划'">{{ measumrePreview.pensionIrrAndBreachMap.irr }}</span>
                <span v-if="measumrePreview.pensionIrrAndBreachMap.irr==='则目前客户储备情况已能满足养老需求'">{{ measumrePreview.pensionIrrAndBreachMap.irr }}</span>
                <span v-if="measumrePreview.pensionIrrAndBreachMap.irr>0">则至少需要达到年化<span class="red">{{ measumrePreview.pensionIrrAndBreachMap.irr| addMoneyFilter}}%</span>的投资收益，才能满足客户的规划需求</span>。
              </li>
              <li>• 根据客户每月储蓄<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.monthMoney| addMoneyFilter}}元</span>，且每年能达成期望投资收益<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.expectedRevenue}}%</span>，
                则当前的家庭养老金

                <span v-if="measumrePreview.pensionIrrAndBreachMap.pensionBreachResult.reserveGap=='1'">资金富余</span>
                <span v-else>存在资金缺口</span>
                <span class="red">
                  {{ measumrePreview.pensionIrrAndBreachMap.pensionBreachResult.reserveBreach | addMoneyFilter }}元</span>
              </li>
              <li>• 根据客户已存家庭养老金<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.currentMoney| addMoneyFilter}}元</span>，且每年能达成期望投资收益<span class="red">{{measumrePreview.pensionIrrAndBreachMap.pensionPlanReserve.expectedRevenue}}%</span>，
                则每月投入的家庭养老金

                <span v-if="measumrePreview.pensionIrrAndBreachMap.pensionBreachResult.monthGap=='1'">资金富余</span>
                <span v-else>存在资金缺口</span>
                <span class="red">{{ measumrePreview.pensionIrrAndBreachMap.pensionBreachResult.monthBreach | addMoneyFilter }}元</span>。
              </li>
            </ul>
          </el-row>
          <!--产品方案-->
          <el-row class="functionBlock"
                  :gutter="20"
                  style="padding:0px 20px 20px 20px;margin:0px;">
            <el-col :span="8">
              <el-checkbox-group v-model="advise.keep"
                                 @change="checkBox(1)">
                <el-checkbox class="checkBox"></el-checkbox>
              </el-checkbox-group>
              <span class="programme">
                <div>
                  <img src="../../../assets/images/wpsp/children-education/椭圆形.png">
                  <span>保守方案</span>
                </div>
                <div ref='suggest1'>
                  <p>该方案适合较为保守的客户，建议选择中低风险的理财、储蓄产品，整体养老规划支出主要依靠未来的资金投入，建议与客户进行深入沟通，建立一个长期的投资计划。</p>
                  <p>目标产品收益：{{programme.conservativeInfoMap.conservativeIncome | emptyCheckFilter}}%</p>
                  <p>起始资金投入：{{programme.conservativeInfoMap.pensionConsInit | emptyCheckFilter| addMoneyFilter}}元</p>
                  <p>后续每月资金投入：{{programme.conservativeInfoMap.pensionConstInvest | emptyCheckFilter| addMoneyFilter}}元</p>
                </div>
              </span>
            </el-col>
            <el-col :span="8">
              <el-checkbox-group v-model="advise.steady"
                                 @change="checkBox(2)">
                <el-checkbox class="checkBox"></el-checkbox>
              </el-checkbox-group>
              <span class="programme">
                <div>
                  <img src="../../../assets/images/wpsp/children-education/矩形.png">
                  <span>稳健方案</span>
                </div>
                <div ref='suggest2'>
                  <p>该方案适合风格稳健，且当前资金压力适中的客户，建议优先选择中等风险的理财、基金产品。整体养老规划支出平衡了当前的一次性投入与未来的持续资金投入，且投资的产品存在一定的风险，需要定时监控产品表现与资产变动。</p>
                  <p>目标产品收益：{{programme.solidInfoMap.solidIncome | emptyCheckFilter}}%</p>
                  <p>起始资金投入：{{programme.solidInfoMap.pensionSolidInit | emptyCheckFilter| addMoneyFilter}}元</p>
                  <p>后续每月资金投入：{{programme.solidInfoMap.pensionSolidInvest | emptyCheckFilter| addMoneyFilter}}元</p>
                </div>
              </span>
            </el-col>
            <el-col :span="8">
              <el-checkbox-group v-model="advise.radical"
                                 @change="checkBox(3)">
                <el-checkbox class="checkBox"></el-checkbox>
              </el-checkbox-group>
              <span class="programme">
                <div>
                  <img src="../../../assets/images/wpsp/children-education/三角形.png" />
                  <span>激进方案</span>
                </div>
                <div ref='suggest3'>
                  <p>该方案较为激进，建议选择中高等风险的理财、基金产品。方案所需要的整体资金量相对较少，但是产品存在较大的波动风险，需要持续关注产品表现与资产变动情况，实时调整。</p>
                  <p>目标产品收益：{{programme.radicalInfoMap.radicalIncome | emptyCheckFilter}}%</p>
                  <p>起始资金投入：{{programme.radicalInfoMap.pensionRadicalInit | emptyCheckFilter| addMoneyFilter}}元</p>
                  <p>后续每月资金投入：{{programme.radicalInfoMap.pensionRadicalInvest | emptyCheckFilter| addMoneyFilter}}元</p>
                </div>
              </span>
            </el-col>
          </el-row>
          <!-- 方案规划 -->
          <el-row class="functionBlock"
                  style="margin-top:20px">
            <div class="Title">方案规划<img style="margin"
                   src="../../../assets/images/wpsp/children-education/info-circle.png" /></div>
            <hr class="titleHr" />
            <div class="selected">
              <br />
              <span class="Title_two">已选产品({{selectedList.length}})</span>
              <div style="margin:0px 20px;">
                <el-table :data="selectedList"
                          height="250"
                          :header-cell-style="{background:'#F5F7FA'}"
                          ref="selectedPrd">
                  <template slot="empty">
                    <span>请选择产品</span>
                  </template>
                  <el-table-column label="产品名称">
                    <template slot-scope="scope">
                      <span v-if="functionList.indexOf('322545212274216960')=='-1'"
                            class='productDecoration'
                            @click='getPrdDetail(scope.row)'>
                        {{scope.row.prdName|prdNameFilterTwo}}</span>
                      <span v-else>{{scope.row.prdName|prdNameFilterTwo}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="产品类型">
                    <template slot-scope="scope">
                      {{scope.row.prdTypeRes}}
                    </template>
                  </el-table-column>
                  <el-table-column label="购买金额（元）"
                                   align="left">
                    <template slot-scope="scope">
                      <el-input :style="{
                        'padding':'5px'}"
                                v-model="scope.row.purchasedMoney"
                                @input.native="scope.row.purchasedMoney=
                            scope.row.purchasedMoney.replace
                            (scope.row.purchasedMoney,RestrictedMoney2
                            (scope.row.purchasedMoney))"
                                size="small"
                                :id="scope.row.id"
                                @focus="checkPurchaseAmounts(scope.row)"
                                @blur="savePurchaseAmounts(scope.row)"
                                :maxlength="purchasedMoneyMaxLength" />
                      <div class="warnText">&ensp;{{scope.row.purchasedMoneyWarn}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作"
                                   align="center">
                    <template slot-scope="scope">
                      <span class="aloneDelBtn"
                            @click="delSelectedPrd(scope.row.id)">删除</span>&emsp;
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <br />
              <span class="Title_two">方案描述</span>
              <div style="margin:10px 20px 20px 20px;">
                <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         class="demo-ruleForm">
                  <el-form-item prop="schemeDescription">
                    <!-- <el-input type="textarea"
                              v-model.trim="ruleForm.schemeDescription"
                              placeholder="请输入方案内容，最多500字"
                              @blur="saveSchemeDescription"
                              maxlength="500"></el-input> -->
                    <el-form-item>
                      <quill-editor v-model="ruleForm.schemeDescription"
                                    ref="myQuillEditor"
                                    :options="editorOption"
                                    @change="onEditorChange($event)"
                                    @blur="saveSchemeDescription">
                      </quill-editor>
                    </el-form-item>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-row>
        </el-col>
        <!--选择产品-->
        <el-col :span="8">
          <el-row class="functionBlock">
            <div class="Title"
                 style="display:flex">
              <div style="width:60%;">选择产品</div>
              <div style="text-align:right;width:100%">
                <el-button type="text"
                           class="title-button"
                           @click="more">查看更多
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </div>
            <hr class="titleHr" />
            <div style="margin:0px 20px;"
                 v-if="productList.length !== 0"
                 class="RegularPrdDiv">
              <div class="product"
                   v-for="(v,i) in productList"
                   :key="i">
                <div v-if="v.prdType === '1'"
                     class="triangle-blue"></div>
                <div v-if="v.prdType !== '1'"
                     class="triangle-green"></div>
                <div v-if="v.prdType === '1'"
                     class="triangle-text-blue">{{v.prdTypeRes}}</div>
                <div v-if="v.prdType !== '1'"
                     class="triangle-text-green">{{v.prdTypeRes}}</div>
                <el-checkbox v-model="v.checked"
                             @change="singleAddPrd(v)"
                             style="width: 16px;height: 16px;position: relative;top: -202px;left: 20px;">
                </el-checkbox>
                <div class="product-two">
                  <ul>
                    <li>{{v.prdName | prdNameFilter}}</li>
                    <li><span class="regularPrdBlueBorder"
                            style="margin-right:10px;"
                            v-if="v.prdType === '1'">{{v.riskLevelRes | emptyCheckFilter}}</span><span class="regularPrdBlueBorder">{{v.statusRes===undefined?v.saleStatus:v.statusRes | emptyCheckFilter}}</span></li>
                    <li v-if="v.prdType === '1'"><span class="product-two-text">业绩比较基准</span><span>{{v.performanceCriterion | emptyCheckFilter}}</span></li>
                    <li v-if="v.prdType === '1'"><span class="product-two-text">投资期限&emsp;&emsp;</span><span>{{v.investTerm | emptyCheckFilter}}天</span></li>
                    <li v-if="v.prdType === '1'"><span class="product-two-text">起购金额&emsp;&emsp;</span><span>{{v.purchaseAmounts | moneyFilter}}元</span></li>
                    <li v-if="v.prdType === '2'"><span class="product-two-text">年利率 &emsp;</span><span>{{v.annualInsrate | emptyCheckFilter}}%</span></li>
                    <li v-if="v.prdType === '2'"><span class="product-two-text">存单期限</span><span>{{v.termLimit }}</span></li>
                    <li v-if="v.prdType === '2'"><span class="product-two-text">起存金额</span><span>{{v.originBuyMoney | moneyFilter}}元</span></li>
                  </ul>
                </div>

              </div>
            </div>
            <div style="margin:0px 20px;"
                 v-if="productList.length === 0">
              <span>暂无常选产品，请点击
                <el-button type="text"
                           class="title-button"
                           @click="more">全部产品
                </el-button>
              </span>
            </div>
          </el-row>
          <el-row class="functionBlock">
            <!--全部产品-->
            <el-dialog title="选择产品"
                       :visible.sync="allPrdVisible"
                       :width="allPrdVisibleWidth"
                       :close-on-press-escape="false"
                       :close-on-click-modal="false"
                       custom-class="prdListDia">
              <el-tabs v-model="prdActiveType"
                       @tab-click="prdActiveChange"
                       style="width:100%">
                <el-tab-pane label="理财"
                             name="finance">
                  <financeTable :selectedTags='selectedTags'
                                ref="financeTable" />
                </el-tab-pane>
                <el-tab-pane label="大额存单"
                             name="disposit">
                  <depositTable :selectedTags='selectedTags'
                                ref="depositTable" />
                </el-tab-pane>
                <el-tab-pane lab
                             el="基金"
                             name="fund">
                  <fundTable></fundTable>
                </el-tab-pane>
              </el-tabs>
              <!-- 已选产品 -->
              <div class="selectedPrds">
                <el-row>
                  <el-col :span="24"><span class="selectedPrdsTitle">已选产品</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="selectedPrdsDiv">
                      <div style="display: block;"
                           v-if="selectedTags.length !== 0">
                        <span class="tagClass"
                              v-for="tag in selectedTags"
                              :key="tag.id">
                          <span class="tagNameClass">{{tag.prdName|prdNameFilter}}</span>
                          <i class="el-icon-close prdTagCloseIcon"
                             @click="handleClose(tag)"></i>
                        </span>
                      </div>
                      <div style="text-align:center"
                           v-if="selectedTags.length === 0">
                        <span style="line-height: 43px;">暂无已选产品</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="search-row"
                        style="text-align:right">
                  <el-button size="medium"
                             @click="closeMoreDialog">取消</el-button>
                  <el-button size="medium"
                             :loading="moreAddLoading"
                             type="primary"
                             @click="addSelectedPrd">确定</el-button>
                </el-row>
              </div>
            </el-dialog>
            <!--产品详情-->
            <financeDetailDialog ref="financeDetailDialog" />
            <depositDetailDialog ref="depositDetailDialog" />
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import { stat } from 'fs';
import { type } from 'os';
import depositTable from './product-table/deposit-table';
import financeTable from './product-table/finance-table';
import fundTable from './product-table/fund-table';
import financeDetailDialog from '../../../components/wpsp/productPlan/financeDetailDialog';
import depositDetailDialog from '../../../components/wpsp/productPlan/depositDetailDialog';

export default {
  name: 'productPlan',
  components: {
    depositTable,
    financeTable,
    fundTable,
    financeDetailDialog,
    depositDetailDialog,
  },
  data() {
    return {
      planType: 2,
      successCode: 'E00000',
      functionList: [],
      advise: {
        // 建议
        keep: false, // 保守
        steady: false, // 稳健
        radical: false, // 激进
      },
      rules: {
        schemeDescription: [
          { required: true, message: '请输入方案描述', trigger: 'blur' },
        ],
      },
      ruleForm: {
        suggestions: '',
        // 方案描述
        schemeDescription: '',
      },
      editorOption: {
        //  富文本编辑器配置
        theme: 'snow',
        placeholder: '请输入方案内容，最多500字',
      },
      // 测算概览
      measumrePreview: {
        riskLevel: '', // 风险等级
        pensionIrrAndBreachMap: {
          pensionPlanReserve: {
            currentMoney: '', // 已存家庭养老金
            monthMoney: '', // 每月投入的养老金
            expectedRevenue: '', // 期望收益
          },
          pensionBreachResult: {
            monthGap: '', // 每月缺口标记：0缺口，1富余
            reserveBreach: '', // 缺口养老金
            reserveGap: '', // 缺口标记：0缺口，1富余
            monthBreach: '', // 养老月缺口
          },
        },
      },
      // 产品方案
      programme: {
        conservativeInfoMap: {
          pensionConsInit: '', // 保守起始资金投入
          conservativeIncome: '', // 类保守目标产品收益
          pensionConsInvest: '', // 后续每月投入
        },
        solidInfoMap: {
          pensionSolidInvest: '', // 稳健后续每月投入
          solidIncome: '', // 稳健目标产品收益
          pensionSolidInit: '', // 稳健起始资金投入
        },
        radicalInfoMap: {
          pensionRadicalInvest: '', // 激进后续每月投入
          radicalIncome: '', // 激进目标产品收益
          pensionRadicalInit: '', // 激进起始资金投入
        },
      },
      // 产品集合
      productList: [],
      // 已选产品
      selectedList: [],
      selectedTags: [],
      allPrdVisible: false,
      allPrdVisibleWidth: '1300px',
      prdActiveType: 'finance',
      // 当前选中的产品编号
      curPrdCode: '',
      // 当前选中的产品类型
      curPrdType: '',
      // 常选产品列表
      regularPrdList: [],
      // 已选产品是否都已配置
      selPrdPicFlag: '',
      // 产品描述是否都已配置
      selPrdDescFlag: '',
      // 方案描述是否不符合要求
      hasError: true,
      // 全局加载
      fullscreenLoading: false,
      // 批量新增时的loading
      moreAddLoading: false,
      // 首次加载产品列表计数器
      firstLoadCount: 0,
      // 购买金额长度
      purchasedMoneyMaxLength: 10,
    };
  },
  computed: {},

  watch: {
    // 如果产品购买金额不满足要求则不允许下一步
    selPrdPicFlag(value) {
      if (value === true && this.selPrdDescFlag === true) {
        this.$emit('set-disabled-flag', false);
        return true;
      }
      this.$emit('set-disabled-flag', true);
    },
    // 如果产品描述金额、购买金额满足要求则不允许下一步
    selPrdDescFlag(value) {
      console.log(value, 'selPrdDescFlag');
      if (value === true && this.selPrdPicFlag === true) {
        this.$emit('set-disabled-flag', false);
        return true;
      }
      this.$emit('set-disabled-flag', true);
    },
    firstLoadCount(value) {
      // 首次进入产品列表页面时，产品列表页面会触发生命周期钩子函数中的方法查询列表，所以除了首次进入，其余的手动查询，刷新数据。
      if (value > 1) {
        console.log(this.$refs.financeTable);
        this.$refs.financeTable.getTableData(1);
      }
    },
    allPrdVisible(value) {
      if (!this.allPrdVisible) {
        this.getSelectedPrdList();
      }
    },
    selectedList(value) {
      if (value.length !== 0) {
        const list = this.productList;
        // 反选操作
        for (let i = 0; i < list.length; i++) {
          const regularPrd = list[i];
          if (this.selectedList.length === 0) {
            regularPrd.checked = false;
          }
          for (let j = 0; j < this.selectedList.length; j++) {
            const selectedPrd = this.selectedList[j];
            if (
              selectedPrd.prdType === regularPrd.prdType
                && selectedPrd.prdCode === regularPrd.prdCode
            ) {
              regularPrd.checked = true;
              break;
            } else {
              regularPrd.checked = false;
            }
          }
        }
      }
    },
  },
  filters: {
    prdNameFilter(value) {
      if (value.length > 15) {
        return `${value.slice(0, 15)}...`;
      }
      return value;
    },
    prdNameFilterTwo(value) {
      if (value.length > 8) {
        return `${value.slice(0, 8)}...`;
      }
      return value;
    },
    // 千分符
    moneyFilter(x) {
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // console.log(f)
      // 如果为空则返回默认值
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        // 补0
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。         👇是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 将分割的入参，重新拼起来  100,000.00
      return parts.join('.');
    },
    termLimitFilter(x) {
      if (x === '' || x === null || x === undefined) {
        return '-';
      }
      if (x === '1') {
        return '1个月';
      }
      if (x === '2') {
        return '3个月';
      }
      if (x === '3') {
        return '6个月';
      }
      if (x === '4') {
        return '9个月';
      }
      if (x === '5') {
        return '1年';
      }
      if (x === '6') {
        return '18个月';
      }
      if (x === '7') {
        return '2年';
      }
      if (x === '8') {
        return '3年';
      }
      if (x === '9') {
        return '5年';
      }
      return '-';
    },
  },
  mounted() {
    this.fullscreenLoading = true;
    // 查询测算概述
    this.getMeasurePreview();
    // 查询推荐方案
    this.getPlans();
    // 查询已选产品
    this.getSelectedPrdList();
    // 查询常选产品
    this.getRegularPrdList();
    // 获取产品方案描述
    this.getSchemeDescription();
    this.fullscreenLoading = false;
  },
  methods: {
    // 获取文本框
    getSuggest(v) {
      if (v === 'keep') {
        this.ruleForm.schemeDescription = this.$refs.suggest1.innerHTML;
        this.ruleForm.suggestions = '1';
      }
      if (v === 'steady') {
        this.ruleForm.schemeDescription = this.$refs.suggest2.innerHTML;
        this.ruleForm.suggestions = '2';
      }
      if (v === 'radical') {
        this.ruleForm.schemeDescription = this.$refs.suggest3.innerHTML;
        this.ruleForm.suggestions = '3';
      }
      console.log(this.$refs.suggest1.innerHTML);
    },
    checkBox(num) {
      // 判断勾选哪个建议
      console.log('调用');
      if (num === 1) {
        this.advise.steady = false;
        this.advise.radical = false;
        if (this.advise.keep) {
          this.getSuggest('keep');
        }
      }
      if (num === 2) {
        this.advise.keep = false;
        this.advise.radical = false;
        if (this.advise.steady) {
          this.getSuggest('steady');
        }
      }
      if (num === 3) {
        this.advise.steady = false;
        this.advise.keep = false;
        if (this.advise.radical) {
          this.getSuggest('radical');
        }
      }
    },
    // 限制富文本框字数
    onEditorChange(event) {
      // console.log(event,'123456789')
      event.quill.deleteText(500, 10);
    },
    // 查询===》测算结论
    getMeasurePreview() {
      const params = {
        data: {
          cis: JSON.parse(sessionStorage.getItem('curCis')),
        },
      };
      this.$_post(this.$API.customerInformation, params)
        .then((res) => {
          if (res.data === undefined) {
            this.measumrePreview = {
              riskLevel: '', // 风险等级
              pensionIrrAndBreachMap: {
                pensionPlanReserve: {
                  currentMoney: '', // 已存家庭养老金
                  monthMoney: '', // 每月投入的养老金
                  expectedRevenue: '', // 期望收益
                },
                monthGap: '', // 每月缺口标记：0缺口，1富余
                pensionBreach: '', // 缺口养老金
                pensionGap: '', // 缺口标记：0缺口，1富余
                pensionMonthBreach: '', // 养老月缺口
              },
            };
            return;
          }
          this.measumrePreview = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询===》建议方案
    getPlans() {
      const params = {
        data: {
          cis: JSON.parse(sessionStorage.getItem('curCis')),
        },
      };
      this.$_post(this.$API.proposedScheme, params)
        .then((res) => {
          if (res.data === undefined) {
            return false;
          }
          this.programme = res.data;
          console.log(this.programme);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 更多产品
    more() {
      this.prdActiveType = 'finance';
      this.allPrdVisible = true;
      // 首次进入产品列表后，首次加载计数器+1。
      this.firstLoadCount += 1;
    },
    // 选择产品tab页切换
    prdActiveChange(tab, event) {
      // 理财
      if (tab.name === 'finance') {
        this.$refs.financeTable.search();
        // 大额存单
      } else if (tab.name === 'disposit') {
        this.$refs.depositTable.search();
      } else if (tab.name === 'fund') {
        // 基金 预留
      }
    },
    // 查询===》常选列表
    getRegularPrdList() {
      const params = {
        data: {
          planType: 2,
          cis: JSON.parse(sessionStorage.getItem('curCis')),
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.regularElectionPrdList, params)
        .then((res) => {
          if (res.data === undefined) {
            this.productList = [];
            return;
          }
          const { list } = res.data;
          // 反选操作
          for (let i = 0; i < list.length; i++) {
            const regularPrd = list[i];
            if (this.selectedList.length === 0) {
              regularPrd.checked = false;
            }
            for (let j = 0; j < this.selectedList.length; j++) {
              const selectedPrd = this.selectedList[j];
              if (
                selectedPrd.prdType === regularPrd.prdType
                && selectedPrd.prdCode === regularPrd.prdCode
              ) {
                regularPrd.checked = true;
                break;
              } else {
                regularPrd.checked = false;
              }
            }
          }
          this.productList = res.data.list;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查询===》已选列表
    getSelectedPrdList(flag) {
      const params = {
        data: {
          planType: 2, // 养老规划
          cis: JSON.parse(sessionStorage.getItem('curCis')),
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.selectedPrdList, params)
        .then((res) => {
          if (res.data === undefined) {
            this.selPrdPicFlag = false;
            this.selectedList = [];
            this.selectedTags = [];
            return;
          }
          const { list } = res.data;
          let selPrdPicCount = 0;
          for (let index = 0; index < list.length; index++) {
            const selectedPrd = list[index];
            selectedPrd.purchasedMoneyWarn = '';
            selectedPrd.purchasedMoneyBorder = '1px solid #EBEEF5';
            // 如果已选产品购买金额为0，则提示错误信息
            if (
              selectedPrd.purchasedMoney === undefined
              || selectedPrd.purchasedMoney <= 0
            ) {
              // 由于后端购买金额为BigDecimal
              selectedPrd.purchasedMoney = '';
              // 不可下一步
              selPrdPicCount++;
            }
            selectedPrd.purchasedMoney = this.moneyFilterMethod(
              selectedPrd.purchasedMoney,
            );
          }
          if (flag === undefined) {
            this.selectedList = list;
          }
          this.selectedTags = list;
          if (selPrdPicCount === 0) {
            this.selPrdPicFlag = true;
          } else {
            this.selPrdPicFlag = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查询===》产品方案描述
    getSchemeDescription() {
      const params = {
        data: {
          planType: 2, // 养老规划
          cis: JSON.parse(sessionStorage.getItem('curCis')),
        },
      };
      this.$_post(this.$API.querySchemeDescription, params)
        .then((res) => {
          if (
            res.data === undefined
            || res.data.info.productPlanDescription === undefined
            || res.data.info.productPlanDescription === ''
          ) {
            this.ruleForm.schemeDescription = '';
            this.selPrdDescFlag = false;
            return false;
          }
          this.ruleForm.schemeDescription = res.data.info.productPlanDescription;
          if (res.data.info.suggestions === '1') {
            this.advise.keep = true;
            this.ruleForm.suggestions = '1';
          }
          if (res.data.info.suggestions === '2') {
            this.advise.steady = true;
            this.ruleForm.suggestions = '2';
          }
          if (res.data.info.suggestions === '3') {
            this.advise.radical = true;
            this.ruleForm.suggestions = '3';
          }
          this.selPrdDescFlag = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 选择产品===》单选
    singleAddPrd(row) {
      // 如果选中则新增
      if (row.checked) {
        if (this.selectedTags.length === 10) {
          row.checked = false;
          this.$message.closeAll();
          this.$message.warning('已选产品不能超过10个');
          return false;
        }
        this.fullscreenLoading = true;
        console.log(row, '*****************************');
        const params = {
          data: {
            prdName: row.prdName,
            prdCode: row.prdCode,
            prdType: row.prdType,
            planType: 2, // 养老规划
            cis: JSON.parse(sessionStorage.getItem('curCis')),
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            prdId: row.prdId,
          },
        };
        this.$_post(this.$API.addRegularPrdSingle, params)
          .then((res) => {
            if (res.errorCode === this.successCode) {
              this.getSelectedPrdList();
              this.getRegularPrdList();
              // 将已选产品加入常选列表的集合中便于下一步时保存常选产品
              const regularPrd = {};
              regularPrd.prdCode = row.prdCode;
              regularPrd.prdType = row.prdType;
              regularPrd.prdName = row.prdName;
              regularPrd.prdId = row.prdId;
              this.regularPrdList.push(regularPrd);
              this.$emit('regular-prd-list', this.regularPrdList);
            } else {
              this.$message.closeAll();
              this.$message({
                message: res.errorMsg,
                type: 'error',
                showClose: true,
              });
              row.checked = false;
            }
          })
          .catch((err) => {
            console.log(err);
            row.checked = false;
          });
        this.fullscreenLoading = false;
      } else {
        for (let index = 0; index < this.selectedTags.length; index++) {
          const element = this.selectedTags[index];
          if (
            element.prdName === row.prdName
            && element.prdType === row.prdType
          ) {
            this.delSelectedPrd(element.id);
            break;
          }
        }
      }
    },
    // 选择产品===》多选
    addSelectedPrd() {
      this.moreAddLoading = true;
      const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          list: this.selectedTags,
          planType: 2, // 养老规划
          cis: JSON.parse(sessionStorage.getItem('curCis')),
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.addBatchSelectedProducts, params)
        .then((res) => {
          if (res.errorCode === this.successCode) {
            this.allPrdVisible = false;
            this.getRegularPrdList();
            this.selectedTags.forEach((row) => {
              // 将已选产品加入常选列表的集合中便于下一步时保存常选产品
              const regularPrd = {};
              regularPrd.prdCode = row.prdCode;
              regularPrd.prdType = row.prdType;
              regularPrd.prdName = row.prdName;
              regularPrd.prdId = row.prdId;
              this.regularPrdList.push(regularPrd);
              this.$emit('regular-prd-list', this.regularPrdList);
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.moreAddLoading = false;
    },
    // 移除已选产品
    handleClose(tag) {
      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
      // 如果是理财产品
      if (tag.prdType === '1') {
        for (
          let index = 0;
          index < this.$refs.financeTable.tableData.length;
          index++
        ) {
          const element = this.$refs.financeTable.tableData[index];
          if (
            element.id === tag.id
            || (element.prdName === tag.prdName && element.prdType === tag.prdType)
          ) {
            element.checked = false;
            break;
          }
        }
        return true;
      }
      // 如果是大额存单
      for (
        let index = 0;
        index < this.$refs.depositTable.tableData.length;
        index++
      ) {
        const element = this.$refs.depositTable.tableData[index];
        if (
          element.id === tag.id
          || (element.prdName === tag.prdName && element.prdType === tag.prdType)
        ) {
          element.checked = false;
          break;
        }
      }
    },
    // 删除===》单个删除已选产品
    delSelectedPrd(id) {
      this.fullscreenLoading = true;
      if (id === '' || id === null || id === undefined) {
        this.$message.closeAll();
        this.$message({
          message: '产品id为空',
          type: 'error',
          showClose: true,
        });
        return;
      }
      const params = {
        data: {
          id,
        },
      };
      this.$_post(this.$API.deleteSelectedProduct, params)
        .then((res) => {
          if (res.errorCode === this.successCode) {
            this.getSelectedPrdList();
            this.getRegularPrdList();
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.fullscreenLoading = false;
    },
    // 查询产品详情
    getPrdDetail(row) {
      // 理财产品
      if (row.prdType === '1') {
        this.$refs.financeDetailDialog.getFinanceDetail(row.prdId);
        // 大额存单
      } else if (row.prdType === '2') {
        this.$refs.depositDetailDialog.getDepositDetail(row.prdId);
      }
    },
    // 新增===》产品购买金额
    savePurchaseAmounts(row) {
      const curPurchasedMoney = this.disMoneyFilterMethod(
        row.purchasedMoney,
      ).replace(/[^\d]/g, '');
      // 如果不符合条件则显示错误信息，且允许下一步
      if (curPurchasedMoney === undefined || curPurchasedMoney === '') {
        this.$set(row, 'purchasedMoneyWarn', '请输入购买金额');
        this.$set(row, 'purchasedMoneyBorder', '1px solid red');
        this.selPrdPicFlag = false;
        row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
        return false;
      }
      if (curPurchasedMoney.length > 10) {
        this.$set(row, 'purchasedMoneyWarn', '购买金额不超过10位正整数');
        this.$set(row, 'purchasedMoneyBorder', '1px solid red');
        this.selPrdPicFlag = false;
        row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
        return false;
      }
      if (curPurchasedMoney < row.purchaseAmounts) {
        this.$set(
          row,
          'purchasedMoneyWarn',
          `${row.prdName}购买金额不能低于${row.purchaseAmounts}`,
        );
        this.$set(row, 'purchasedMoneyBorder', '1px solid red');
        this.selPrdPicFlag = false;
        row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
        return false;
      }
      if (curPurchasedMoney > row.perBuyMaxMoney) {
        this.$set(row, 'purchasedMoneyWarn', '购买金额超限');
        this.$set(row, 'purchasedMoneyBorder', '1px solid red');
        this.selPrdPicFlag = false;
        row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
        return false;
      }
      if (
        curPurchasedMoney !== row.purchaseAmounts.toString()
        && (curPurchasedMoney - row.purchaseAmounts) % row.increaseAmount > 0
      ) {
        this.$set(
          row,
          'purchasedMoneyWarn',
          `${row.prdName}购买金额需按${row.increaseAmount}递增`,
        );
        this.$set(row, 'purchasedMoneyBorder', '1px solid red');
        this.selPrdPicFlag = false;
        row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
        return false;
      }
      const params = {
        data: {
          id: row.id,
          purchasedMoney: curPurchasedMoney,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.singleProductPurchase, params)
        .then((res) => {
          if (res.errorCode === this.successCode) {
            this.$set(row, 'purchasedMoneyWarn', '');
            this.$set(row, 'purchasedMoneyBorder', '1px solid #EBEEF5');
            row.purchasedMoney = this.moneyFilterMethod(curPurchasedMoney);
            // 传1代表不刷新列表
            this.getSelectedPrdList(1);
          } else {
            this.$message.closeAll();
            this.$message.error(res.errorMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取焦点时去掉千分符和小数点
    checkPurchaseAmounts(row) {
      row.purchasedMoney = this.disMoneyFilterMethod(row.purchasedMoney);
    },
    // 新增===》产品方案描述
    saveSchemeDescription() {
      if (this.ruleForm.schemeDescription === '') {
        this.selPrdDescFlag = false;
        return true;
      }
      let str = this.ruleForm.schemeDescription;
      str = str.replace(/\s*/g, '');
      console.log('字符串之后的数据--参数', str);
      const params = {
        data: {
          productPlanDescription: str,
          planType: 2, // 养老规划
          suggestions: this.ruleForm.suggestions,
          cis: JSON.parse(sessionStorage.getItem('curCis')),
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.schemeDescription, params)
        .then((res) => {
          if (res.errorCode === this.successCode) {
            this.getSchemeDescription();
          } else {
            this.$message.closeAll();
            this.$message.error(res.errorMsg);
            this.selPrdDescFlag = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 关闭更多产品模态框
    closeMoreDialog() {
      this.allPrdVisible = false;
    },
    // 金额增加千分符
    moneyFilterMethod(x) {
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // console.log(f)
      // 如果为空则返回默认值
      if (isNaN(f)) {
        return '';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        // 补0
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。         👇是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 将分割的入参，重新拼起来  100,000.00
      return parts.join('.');
    },
    // 去掉千分符
    disMoneyFilterMethod(x) {
      let a = x.toString();
      if (a.indexOf(',') !== -1) {
        a = a.replace(new RegExp(',', 'g'), '');
      }
      if (a.indexOf('.') != -1) {
        a = a.substring(0, a.indexOf('.'));
      }
      return a;
    },
    RestrictedMoney2(values) {
      return this.plusOrMinus2(values.toString());
    },

    plusOrMinus2(values) {
      return values.replace(/[^0-9]/g, '');
    },
  },
};
</script>
<style>
.prdListDia .el-dialog__body {
  padding-top: 0px;
}
.prdListDia .el-tabs__nav-wrap::after {
  height: 0px;
}
</style>
<style lang="scss" scoped>
.top,
.bottom {
  margin-bottom: 16px;
}
.left {
  display: inline-block;
  height: 560px;
  width: 65.68%;
  background: rgba(255, 255, 255, 1);
}
// .right {
//   position: absolute;
//   display: inline-block;
//   margin-left: 16px;
//   width: 32.93%;
//   min-height: 560px;
//   background: rgba(255, 255, 255, 1);
// }
.Title {
  padding: 16px 20px;
  font-size: 18px;
  font-weight: 400;
  color: rgba(48, 49, 51, 1);
  line-height: 24px;
}
.Title_two {
  font-size: 16px;
  color: rgba(48, 49, 51, 1);
  line-height: 24px;
  margin: 0px 20px;
}
.Title img {
  width: 16px;
  height: 16px;
  position: relative;
  top: 1px;
}
.Title .title-button {
  font-weight: 400;
  font-size: 14px;
  padding: 0px;
}
.textPart {
  font-size: 14px;
  padding: 16px 20px;
}
.textPart .red {
  color: #fa6b6b;
}
.programme {
  vertical-align: top;
  padding: 16px 18px;
  display: inline-block;
  height: 360px;
  background: rgba(245, 247, 250, 1);
  border-radius: 2px;
  overflow: hidden;
}
.programme-Two {
  margin: 0px 1%;
}
.programme img {
  position: relative;
  top: 4px;
  margin-right: 10px;
}
.programme div:nth-child(1) {
  height: 14px;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 15px;
}
.programme div:nth-child(2) {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 21px;
}
.product {
  width: 100%;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(235, 238, 245, 1);
  overflow: hidden;
  margin: 20px 0px;
}
.product > .product-two {
  padding: 0px 0px 20px 50px;
  position: relative;
  top: -220px;
}
.product li {
  margin-bottom: 10px;
}
.product li:nth-child(1) {
  color: rgba(48, 49, 51, 1);
}
.regularPrdBlueBorder {
  display: inline-block;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: rgba(30, 136, 255, 1);
  width: 56px;
  height: 20px;
  border: 1px solid rgba(30, 136, 255, 1);
}
.product li:nth-child(3),
.product li:nth-child(4),
.product li:nth-child(5),
.product li:nth-child(6),
.product li:nth-child(7),
.product li:nth-child(8) {
  color: rgba(96, 98, 102, 1);
  font-size: 12px;
}
.product-two-text {
  margin-right: 20px;
}
.product li:nth-child(3) span {
  color: rgba(249, 83, 83, 1);
}

.triangle-blue {
  width: 200px;
  height: 200px;
  background: #1e88ff;
  transform: rotate(45deg);
  position: relative;
  right: -93%;
  top: -70%;
}
.triangle-green {
  width: 200px;
  height: 200px;
  background: #13ce66;
  transform: rotate(45deg);
  position: relative;
  right: -93%;
  top: -70%;
}
.triangle-text-blue {
  width: 24px;
  height: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  position: relative;
  left: 91%;
  top: -124%;
}
.triangle-text-green {
  width: 24px;
  height: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  position: relative;
  left: 91%;
  top: -130%;
}
.selectedPrdsTitle {
  font-size: 20px;
}
.selectedPrdsDiv {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0 50px 0;
}
.prdTag {
  margin: 5px 10px;
}
.productDecoration {
  border-bottom: 1px solid #1e88ff;
  color: #1e88ff;
  cursor: pointer;
}
.ipt-number {
  width: 100%;
}
.RegularPrdDiv {
  margin-bottom: 10%;
}
.aloneDelBtn {
  font-size: 12px;
  color: #f95353;
}
.aloneDelBtn:hover {
  cursor: pointer;
}

.warnText {
  color: red;
  font-size: 12px;
}
.hasErrorClass {
  border: 1px solid red;
}
.schemeDescriptionClass {
  margin-top: 10px;
  resize: none;
  width: 100%;
  border-radius: 5px;
}
.functionBlock:nth-child(2) {
  margin-top: 0px;
}
.functionBlock {
  background-color: white;
  .checkBox {
    position: absolute;
    left: 86%;
    top: 3px;
    .el-checkbox__inner {
      width: 20px !important;
      height: 20px !important;
    }
    .el-checkbox__inner::after {
      height: 10px;
      left: 8px;
    }
  }
  .el-col-8 {
    position: relative;
  }
}
.titleHr {
  background-color: #f7f7f7;
  height: 2px;
  border: none;
}
.prdTagCloseIcon:hover {
  cursor: pointer;
}
.tagClass {
  margin: 5px 10px;
  background-color: #edf6ff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #92979c;
  border-radius: 1px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
.tagNameClass {
  margin-right: 30px;
  padding: 0px;
}
</style>
